import { apiSlice } from "./apiSlice";
import { EQUIPMENT_URL } from "../constants";

const equipmentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createEquipment: builder.mutation({
      query: (data) => ({
        url: `${EQUIPMENT_URL}`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getEquipments: builder.query({
      query: (data) => ({
        url: `${EQUIPMENT_URL}?${data.query ? data.query : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    updateEquipment: builder.mutation({
      query: (data) => ({
        url: `${EQUIPMENT_URL}/${data._id}`,
        method: "PUT",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateEquipmentMutation,
  useGetEquipmentsQuery,
  useUpdateEquipmentMutation,
} = equipmentApiSlice;
